// extracted by mini-css-extract-plugin
module.exports = {"ProjectContainer":"ProjectContainer-module--ProjectContainer--17G1E"};